import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RootProviders } from './RootProviders';
import { SidebarProvider } from './context/SidebarContext';
import "./styles/theme.css";

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <RootProviders>
      <SidebarProvider>
        <App />
      </SidebarProvider>
    </RootProviders>
  </React.StrictMode>
);

reportWebVitals();
